import { useMemo } from 'react';

import type { PageIncludeMacroParams } from '../pageIncludeMacroTypes.ts';

export const useSerializedMacroParameters = (
	macroParams: PageIncludeMacroParams | undefined,
): string => {
	return useMemo(() => (macroParams ? JSON.stringify(macroParams) : ''), [macroParams]);
};
